import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export default function AdminLayout() {
  const { t, i18n } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleLang = () => {
    i18n.changeLanguage(i18n.language === 'ar' ? 'en' : 'ar');
  };

  async function handleLogout() {
    try {
      await logout();
      toast.success(t('admin.loggedOut'));
      navigate('/admin/login');
    } catch {
      toast.error('Failed to log out');
    }
  }

  return (
    <div className="admin-layout" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="admin-sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="admin-sidebar-header">
          <div className="admin-logo">
            <span className="admin-logo-text">Wojod Link</span>
            <span className="admin-logo-sub">{t('admin.panelTitle')}</span>
          </div>
          <button className="admin-sidebar-close" onClick={() => setSidebarOpen(false)}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <nav className="admin-nav">
          <NavLink to="/admin" end className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
            <i className="fas fa-chart-line"></i>
            <span>{t('admin.dashboard')}</span>
          </NavLink>
          <NavLink to="/admin/blogs" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
            <i className="fas fa-blog"></i>
            <span>{t('admin.blogPosts')}</span>
          </NavLink>
          <NavLink to="/admin/contacts" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
            <i className="fas fa-envelope"></i>
            <span>{t('admin.contactMessages')}</span>
          </NavLink>
          <NavLink to="/admin/newsletter" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
            <i className="fas fa-newspaper"></i>
            <span>{t('admin.newsletter')}</span>
          </NavLink>
          <NavLink to="/admin/faqs" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
            <i className="fas fa-question-circle"></i>
            <span>{t('admin.faqManagement')}</span>
          </NavLink>
        </nav>

        <div className="admin-sidebar-footer">
          <button className="admin-nav-link" onClick={toggleLang}>
            <i className="fas fa-globe"></i>
            <span>{t('langSwitch')}</span>
          </button>
          <a href="/" className="admin-nav-link" target="_blank" rel="noopener noreferrer">
            <i className="fas fa-external-link-alt"></i>
            <span>{t('admin.viewWebsite')}</span>
          </a>
          <button className="admin-nav-link admin-logout-btn" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt"></i>
            <span>{t('admin.logout')}</span>
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="admin-main">
        <header className="admin-topbar">
          <button className="admin-menu-toggle" onClick={() => setSidebarOpen(true)}>
            <i className="fas fa-bars"></i>
          </button>
          <div className="admin-topbar-title">{t('admin.panelTitle')}</div>
        </header>
        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
